/** *************************************************************
 * Copyright (c) 2006 - 2021, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 09/25/2019
 *
 * @version 0.1
 * Revisions:
 * 09/25/2019 - BW - Initial Creation
 *
 * Description/Purpose:
 * Browser Data JS
 * Ajax Get that calls BE Java process to set browser session data
 * @publish PUBSUB_EVENT.SET_BROWSER_DATA_COMPLETE
 ************************************************************** */
import PUBSUB_EVENT from 'constant/pubsub-event';
import { PAGE_PARAM } from 'constant/app-constant';
import HTML5SupportUtil from 'util/html5-support';
import PubSub from 'pubsub-js';
import StackTraceError from "component/stack-trace-error/stack-trace-error";


const BrowserData = {


  /**
   *
   */
  setBrowserData() {
    try {
      const $loginServlet = $('#login_servlet_url');
      const $act = $('#act_set_browser_session_data');
      const data = `${PAGE_PARAM.ACT}=${$act.val()}`
          + `&${PAGE_PARAM.BROWSER_FILE_API_SUPPORT}`
          + `=${HTML5SupportUtil.hasFileAPI()}`
          + `&${PAGE_PARAM.BROWSER_IS_IOS}`
          + `=${BrowserData.isIOS()}`
          + `&${PAGE_PARAM.BROWSER_TIME_ZONE_ID}`
          + `=${BrowserData.getBrowserTimeZoneId()}`;

      // Run ajax
      $.get($loginServlet.val(), data)
        .always(() => {
          // Publish event
          PubSub.publish(PUBSUB_EVENT.SET_BROWSER_DATA_COMPLETE);
        });
    } catch (e) {
      StackTraceError.processError(e, 'Browser Data');
    }
  },


  /**
   * Is IOS?
   * @returns {boolean|boolean}
   */
  isIOS() {
    return (/iPad|iPhone|iPod/.test(navigator.platform)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
        && !window.MSStream;
    // const iosQuirkPresent = function () {
    //   const audio = new Audio();
    //   audio.volume = 0.5;
    //   return audio.volume === 1;   // volume cannot be changed from "1" on iOS 12 and below
    // };
    //
    // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    // const isAppleDevice = navigator.userAgent.includes('Macintosh');
    // const isTouchScreen = navigator.maxTouchPoints >= 1;   // true for iOS 13 (and hopefully beyond)
    //
    // return isIOS || (isAppleDevice && (isTouchScreen || iosQuirkPresent()));
  },


  /**
   * Get Browser Time Zone Id
   * @returns {string}
   */
  getBrowserTimeZoneId() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  },



};

export default BrowserData;
